import { every, isEmpty, some } from 'lodash'

import { unformat } from './telephone'

export const isCountryCodeValid = (countryCode) =>
  (!countryCode && countryCode !== 0) || (countryCode > 0 && countryCode <= 999999)
// need to confirm with BE, can fail for explicit reasons I think like invalid country + phone, but must phone be 10d?
export const isPhoneValid = (phone) => {
  const n = unformat(phone)
  return some([isEmpty(n), every([n !== '1234567890'])])
}
